import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Divider, Button, Dialog, Grid, TextField, Typography, IconButton, DialogTitle, DialogContent, DialogActions, Chip, Paper, Table, Box, Select, MenuItem, FormControl, FormControlLabel, InputLabel, Checkbox, ListItem, ListItemText, TableContainer, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { createSubOrg, createServiceLine, geocodeServiceAddress } from "../slice";
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";
import { setLoading } from "../../../UserScreen/Starlink/slice";
import { getDataFromLocalStorageParsed, getDecodeURI } from "../../../utils/util";
import CustomLoader from "../../Loader/CustomLoaders";
import { Add, Remove } from '@mui/icons-material';
import "./index.css"
import { formatStarlinkId, patterns, validateKITInput } from "../../../utils/util";
import { getServiceLinesByStatusAPI } from "../../StarlinkDashboard/slice";

type DataBlockState = {
    [productId: string]: number;
};


function CreateServiceLineDialog(props) {

    const { open, onClose, onSave, data, createServiceLine, geocodeServiceAddress, location, selectedServiceAccount, getServiceLinesByStatusAPI, dpIds, authReducer, newSummaryServiceAccount } = props;
    const params = getDecodeURI(location.search)
    const [selectedOu, setSelectedOu] = useState(params?.ouId)
    const [emailInput, setEmailInput] = useState('');
    const [emails, setEmails] = useState<any[]>([]);
    const [error, setError] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('All');
    const [userTerminalArray, setUserTerminalArray] = useState([])
    const [filteredTerminalArray, setFilteredTerminalArray] = useState<any>([])
    const [selectedTerminals, setSelectedTerminals] = useState<any>([]);
    const [confirmDialog, setConfirmDialog] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState(false);
    const [formattedSubscriptionDetails, setFormattedSubscriptionDetails] = useState<any>([]);
    const [formattedData, setFormattedData] = useState<any>([]);
    const [inputValue, setInputValue] = useState("");
    const [validationResult, setValidationResult] = useState<any>(null);
    const [dataBlocks, setDataBlocks] = useState<DataBlockState>({});
    const [notes, setNotes] = useState('');
    const [mobileTerminal, setMobileTerminal] = useState(true);
    const [addressSuggestions, setAddressSuggestions] = useState<any[]>([]);
    const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
    const [addressSearchInput, setAddressSearchInput] = useState('');
    const [selectedAddress, setSelectedAddress] = useState<any>(null);
    const [savedAddresses, setSavedAddresses] = useState<any[]>([]);
    const skipNextAddressSearchRef = useRef(false);
    const isAllServiceLineUser =  getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.allServiceLineUser

    useEffect(() => {
        if (data?.custom_plans && data?.available_products) {
            setUserTerminalArray(data?.user_terminals)
            setSavedAddresses(Array.isArray(data?.address) ? data.address : [])

            const groupCustom = () => {
                const map = new Map();

                data.custom_plans.forEach(plan => {
                    plan.details.forEach(detail => {
                        const acc = detail.account_number;

                        if (!map.has(acc)) map.set(acc, {
                            account_number: acc,
                            plans: []
                        });

                        map.get(acc).plans.push({
                            label: plan.plan_name,
                            data: plan.details,
                            type: 'custom'
                        });
                    });
                });

                return Array.from(map.values());
            };

            const groupStandard = () => {
                const map = new Map();

                data.available_products
                    .filter(p => p.active)
                    .forEach(product => {
                        product.plan_details.forEach(detail => {
                            const acc = detail.account_number;

                            if (!map.has(acc)) map.set(acc, {
                                account_number: acc,
                                plans: []
                            });

                            map.get(acc).plans.push({
                                ...product,
                                label: `${product.name} • $${product.price} • ${product.iso_currency_code}`,
                                data: product.plan_details,
                                type: 'standard'
                            });
                        });
                    });

                return Array.from(map.values());
            };

            const groupedCustom = groupCustom();
            const groupedStandard = groupStandard();

            const formatted: any = [];

            formatted?.push({ type: 'header', label: 'Custom Plans' });

            groupedCustom?.forEach(group => {
                formatted?.push({
                    type: 'account',
                    label: `${group.account_number}`,
                    disabled: true
                });

                group?.plans?.forEach(plan => {
                    formatted?.push(plan);
                });
            });

            formatted?.push({ type: 'header', label: 'Standard Plans' });

            groupedStandard?.forEach(group => {
                formatted?.push({
                    type: 'account',
                    label: `${group.account_number}`,
                    disabled: true
                });

                group?.plans?.forEach(plan => {
                    formatted?.push(plan);
                });
            });

            setFormattedData(formatted);
            setFormattedSubscriptionDetails(formatted)
         }

    }, [data])

    const [formData, setFormData] = useState<any>({
        nickname: '',
        subscriptionType: null,
        serviceAddress: null,
        terminalId: null
    });

    const clearData = () => {
        setFormData({
            nickname: '',
            subscriptionType: null,
            serviceAddress: null,
            terminalId: null
        })
        setEmails([])
        setSelectedTerminals([])
        setLoading(false)
        setSelectedAccount('All')
        setSelectedAddress(null)
        setAddressSearchInput('')
        setAddressSuggestions([])
        setMobileTerminal(true)
    }

    useEffect(() => {
        if (formData?.subscriptionType && selectedAccount !== "") {
          const groupedOptions: any[] = [];
      
          const sortedArray = [...userTerminalArray].sort((a:any, b:any) =>
            (a.account_number || '').localeCompare(b.account_number || '')
          );
      
          let currentAccount: string | null = null;

      
          sortedArray.forEach((item:any) => {
            const account = item?.account_number || "Unknown Account";
      
            if (account !== currentAccount) {
              groupedOptions.push({
                label: `Account ${account}`,
                isHeader: true,
              });
              currentAccount = account;
            }
      
            groupedOptions.push({
              label: `${item?.user_terminal_id} - ${item?.kit_serial_number} - ${item?.dish_serial_number}`,
              userTerminal: item?.user_terminal_id,
              kitSerialNumber: item?.kit_serial_number,
              dishSerialNumber: item?.dish_serial_number,
              accountNumber: account,
              isHeader: false,
            });
          });
      
          setFilteredTerminalArray(groupedOptions);
        }
      }, [formData?.subscriptionType, selectedAccount, userTerminalArray]);
      
      

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const handleDeleteEmail = (emailToDelete: string) => {
        setEmails(emails.filter(email => email !== emailToDelete));
    };

    const handleAddEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && emailInput) {
            event.preventDefault();
            if (validateEmail(emailInput)) {
                setEmails([...emails, { name: emailInput.split('@')[0].replace('.', ' ').replace(/\b\w/g, char => char.toUpperCase()), email: emailInput }]);
                setEmailInput('');
                setError('');
            } else {
                setError('Invalid email address');
            }
        }
    };

    useEffect(() => {
        if (skipNextAddressSearchRef.current) {
            skipNextAddressSearchRef.current = false;
            return;
        }

        const query = addressSearchInput?.trim() || '';
        if (query.length < 3) {
            setAddressSuggestions([]);
            setIsFetchingSuggestions(false);
            return;
        }

        let cancelled = false;
        setIsFetchingSuggestions(true);
        const timer = setTimeout(async () => {
            try {
                const res: any = await geocodeServiceAddress({ address: query });
                if (cancelled) return;
                if (res?.success && Array.isArray(res?.data?.results)) {
                    setAddressSuggestions(res.data.results);
                } else {
                    setAddressSuggestions([]);
                    if (res && res.success === false && res?.message) {
                        toast.error(res.message, { position: toast.POSITION.BOTTOM_LEFT });
                    }
                }
            } catch (e: any) {
                if (cancelled) return;
                setAddressSuggestions([]);
                toast.error(e?.response?.data?.message || e?.message || 'Failed to fetch address suggestions', {
                    position: toast.POSITION.BOTTOM_LEFT
                });
            } finally {
                if (!cancelled) setIsFetchingSuggestions(false);
            }
        }, 500);

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [addressSearchInput]);

    const toNum = (v: any) => {
        const n = typeof v === 'number' ? v : parseFloat(v);
        return Number.isFinite(n) ? n : null;
    };

    const handleAddressSelect = (option: any) => {
        if (!option) {
            setSelectedAddress(null);
            setFormData({ ...formData, serviceAddress: null });
            return;
        }

        setSelectedAddress(option);

        // Saved address — already in backend snake_case shape; strip our internal __source marker
        // and coerce latitude/longitude to numbers (backend rejects strings).
        if (option.__source === 'saved') {
            const { __source, ...savedClean } = option;
            setFormData({
                ...formData,
                serviceAddress: {
                    ...savedClean,
                    latitude: toNum(savedClean.latitude),
                    longitude: toNum(savedClean.longitude),
                },
            });
            return;
        }

        // Geo API result — camelCase, map to backend snake_case
        setFormData({
            ...formData,
            serviceAddress: {
                address_lines: option.addressLines || [],
                administrative_area_code: option.administrativeAreaCode || '',
                formatted_address: option.formattedAddress || '',
                latitude: toNum(option.latitude),
                longitude: toNum(option.longitude),
                region_code: option.regionCode || '',
                locality: option.locality || '',
                administrative_area: option.administrativeArea || '',
                region: option.region || '',
                postal_code: option.postalCode || ''
            },
        });
    };

    // Combined options: Search results (geo API) on top + Saved list (filtered) on bottom, each with a header.
    const combinedAddressOptions = React.useMemo(() => {
        const query = (addressSearchInput || '').toLowerCase().trim();
        const opts: any[] = [];

        if (addressSuggestions.length > 0) {
            opts.push({ __source: 'header', label: `Search results (${addressSuggestions.length})` });
            addressSuggestions.forEach((s: any) => opts.push({ ...s, __source: 'geo' }));
        }

        const filteredSaved = (savedAddresses || []).filter((s: any) => {
            if (!query) return true;
            return (s?.formatted_address || '').toLowerCase().includes(query);
        });

        if (filteredSaved.length > 0) {
            opts.push({ __source: 'header', label: `Saved list (${filteredSaved.length})` });
            filteredSaved.forEach((s: any) => opts.push({ ...s, __source: 'saved' }));
        }

        return opts;
    }, [addressSuggestions, savedAddresses, addressSearchInput]);

    const handleChange = (field, value) => {
        setFormData({
            ...formData,
            [field]: value
        });
    };

    const handleSubmit = async () => {
        if (selectedAccount !== "All" && selectedTerminals && selectedTerminals?.accountNumber && selectedTerminals?.accountNumber !== selectedAccount) {
            setConfirmDialog(true)
        } else {
            createServiceLines()
        }
    };


    const createServiceLines = async () => {
        setIsLoading(true);
        try {

            const dataBlockProducts = Object.entries(dataBlocks || {})
                ?.map(([productId, count]) => ({
                    productId,
                    count
                }))

            let params = {
                name: formData?.nickname,
                customPlanId: formData?.subscriptionType?.data && formData?.subscriptionType?.data?.length > 0 ? formData?.subscriptionType?.data[0]?.custom_plan_id : "",
                productReferenceId: formData?.subscriptionType?.plan_details && formData?.subscriptionType?.plan_details?.length > 0 ? formData?.subscriptionType?.plan_details[0]?.product_reference_id : "",
                accountNumber: selectedAccount,
                address: formData?.serviceAddress,
                organizationId: authReducer?.selectedOu?.id,
                userTerminalId: formData?.terminalId,
                emailIds: emails,
                dataBlockProducts: dataBlockProducts,
                type: validationResult?.type !== "LIST_OPTION" ? validationResult?.type : "",
                notes: notes,
                mobileTerminal: mobileTerminal

            }

            if(authReducer?.selectedOu?.id){
                let res: any = await createServiceLine(params)
                if (res?.success) {
                        setIsLoading(false);
                        onClose();
                        clearData();
                        toast.success(`${formData?.nickname} Service Line created successfully. Please check after some time`, {
                            position: toast.POSITION.BOTTOM_LEFT,
                        })

                    const serviceLinesParam = isAllServiceLineUser
                        ? "''"
                        : authReducer?.fetchServiceLines?.serviceLines?.length
                            ? authReducer.fetchServiceLines.serviceLines.map(item => `'${item.id}'`).join(',')
                            : "''";

                    const accountNumbersParam =
                        newSummaryServiceAccount?.length === selectedServiceAccount?.length
                            ? []
                            : selectedServiceAccount;

                    getServiceLinesByStatusAPI({
                        dpIds,
                        subscriptionStatus: "'all'",
                        accountNumbers: accountNumbersParam,
                        serviceLines: serviceLinesParam
                    });
    
                } else {
                    toast.error(`Unable to create Service Line - ${formData?.nickname} `, {
                        position: toast.POSITION.BOTTOM_LEFT
                    });
                    setIsLoading(false);
                    //  onClose();
                }
            }

        } finally {
            setIsLoading(false);
            // onClose();
            // clearData();
        }
    }

    const handleChangeAccountNumber = (e) => {
        
        setFormData({
            nickname: formData?.nickname,
            subscriptionType: null,
            serviceAddress: formData?.serviceAddress,
            terminalId: formData?.terminalId
        })
        const selectedValue = e.target.value;
        setSelectedAccount(selectedValue);
      
        let formattedData: any = [];
      
        if (selectedValue === "All") {
          formattedData = [...formattedSubscriptionDetails];
        } else {
          formattedData = formattedSubscriptionDetails.filter(item => {
            const isCustomOrStandard = item?.label === 'Custom Plans' || item?.label === 'Standard Plans';
            const hasMatchingAccount = item?.data?.[0]?.account_number === selectedValue;
      
            return isCustomOrStandard || hasMatchingAccount;
          });
        }
      
        setFormattedData(formattedData);
      };

    const handleInputChange = (
        newValue: string,
        setInputValue: (v: string) => void
    ) => {
        if (newValue.includes(",")) return;

        let formatted = newValue;
        if (/^[0-9a-f]{5,}$/i.test(newValue)) {
            formatted = formatStarlinkId(newValue);}
        setInputValue(formatted);
    };

    const handleOptionChange = (  newValue: any,   setValidationResult: (v: any) => void, setSelectedTerminals: (v: any) => void,handleChange: (key: string, value: any) => void,
        validateKITInput: (raw: string) => any
    ) => {
        if (!newValue) return;

        if (newValue.isNew){
            const raw = newValue?.userTerminal;
            const result = validateKITInput(raw);
            setValidationResult(result);

            if (result.valid) {
                setSelectedTerminals({ label: raw, userTerminal: raw });
                handleChange("terminalId", raw);
            }
            return;
        }

        if (!newValue.isHeader) {
            setValidationResult({ id: newValue.userTerminal, type: "LIST_OPTION", valid: true })
            setSelectedTerminals(newValue)
            handleChange("terminalId", newValue.userTerminal)
     }
    }

    const filterTerminalOptions = (options:any[], state: any)=>{
        const filtered = options?.filter((opt: any) =>   opt?.label?.toLowerCase()?.includes(state.inputValue.toLowerCase()) );
        if (
            state.inputValue !== ""&&
            !options?.some((opt: any) => opt?.label?.toLowerCase() === state?.inputValue?.toLowerCase())
        ) {
            filtered.push({
                label: `${state?.inputValue}`,
                userTerminal: state?.inputValue,
                isNew: true
            });
        }

        return filtered;
    }

    const renderTerminalOption = (props: React.HTMLAttributes<HTMLLIElement>, option: any) => {
        if (option?.isHeader) {
            return ( <li
                    {...props}
                    style={{
                        pointerEvents: "none",
                        backgroundColor: "#f5f5f5",
                        fontWeight: "bold",
                    }}
                >
                    {option?.label}
                </li>
            );
        }

        if (option?.isNew){
            return ( <li {...props} style={{ fontStyle: "italic" }}>
                    Add "{option?.label}" (Add to warehouse - BETA Feature)
                </li>
            );
        }

        return <li {...props}>{option?.label}</li>
    };

    return (
        <>
            <Dialog open={open} onClose={() => { clearData(); onClose(); }} maxWidth="sm" fullWidth>
                <DialogTitle>
                    ADD SERVICE LINE
                </DialogTitle>
                <DialogContent> 
                    <Typography variant="body2">
                        Add a new service line. This will incur charges according to your account contract.
                    </Typography>
                    <Grid container spacing={2} marginTop={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Alias"
                                value={formData.nickname}
                                onChange={(e) => handleChange('nickname', e.target.value)}
                                size="small"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel style={{ marginTop: "-3px" }} id="demo-simple-select-label">Account Number</InputLabel>
                                <Select
                                    size="small"
                                    // disabled={true}
                                    fullWidth
                                    labelId="demo-simple-select-label"
                                    label='Account Number'
                                    id="demo-simple-select"
                                    value={selectedAccount}
                                    onChange={(e) => { handleChangeAccountNumber(e) }}
                                >
                                    {newSummaryServiceAccount?.map((d) => {
                                        return (
                                            <MenuItem key={d.accountNumber} value={d.accountNumber}>
                                             {d.accountName} ( {d.accountNumber} )
                                            </MenuItem>
                                        )
                                    })}

                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                disableClearable
                                options={formattedData}
                                value={formData?.subscriptionType}
                                onChange={(event, newValue: any) => {
                                    if (newValue?.type === "header" || newValue?.type === "account") {
                                        event.preventDefault();
                                        return;
                                    }
                                    setEmails([])
                                    setSelectedAccount(newValue?.data && newValue?.data[0]?.account_number)
                                    handleChange('subscriptionType', newValue || '');
                                    // setSelectedAccount(newValue?.data && newValue?.data[0]?.account_number)
                                    if (newValue?.details) {
                                        setEmails([...newValue?.parent_pool?.users_to_notify, ...newValue?.users_to_notify])
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} label="Subscription Type" size="small" />}
                                getOptionLabel={(option) => option.label}
                                renderOption={(props, option) => (
                                    <React.Fragment key={option.label}>
                                        {option.type === "header" || option.type === "account" ? (
                                            <li
                                                {...props}
                                                className="create-service-line-account"
                                            >
                                                {option.label}
                                            </li>
                                        ) : (
                                            <li {...props} style={{paddingLeft:"35px"}}>{option.label}</li>
                                        )}
                                        {option.hasDivider && <Divider />}
                                    </React.Fragment>
                                )}
                            />
                        </Grid>

                        {
                            formData?.subscriptionType?.data_block_products && formData?.subscriptionType?.data_block_products?.length > 0 ?
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} className="starlink--table_container ">
                                        <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><strong>Data</strong></TableCell>
                                                    <TableCell><strong>Price</strong></TableCell>
                                                    <TableCell><strong>Data Block</strong></TableCell>
                                                    <TableCell><strong>Total Data</strong></TableCell>
                                                    <TableCell><strong>Total Price</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {formData?.subscriptionType?.data_block_products.map((row, index) => {
                                                    const key = row.product_id;
                                                    const blocks = dataBlocks[key] || 0;
                                                    const totalRowData = blocks * row.data_amount;
                                                    const totalRowPrice = blocks * row.price;

                                                    return (
                                                        <TableRow key={key}>
                                                            <TableCell>{`${row.data_amount} ${row.data_unit}`}</TableCell>
                                                            <TableCell>{`${row.price} ${row.iso_currency_code}`}</TableCell>
                                                            <TableCell>{`${totalRowData} ${row.data_unit}`}</TableCell>
                                                            <TableCell>{`${totalRowPrice.toFixed(2)} ${row.iso_currency_code}`}</TableCell>
                                                            <TableCell className="data-block-cell">
                                                                <Box className="data-block-wrapper">
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            setDataBlocks((prev) => ({
                                                                                ...prev,
                                                                                [key]: Math.max((prev[key] || 0) - 1, 0),
                                                                            }));
                                                                        }}
                                                                        size="small"
                                                                        className="data-block-button"
                                                                    >
                                                                        <Remove fontSize="small" />
                                                                    </IconButton>

                                                                    <input
                                                                        type="number"
                                                                        className="data-block-input data-block-no-spinner"
                                                                        min="0"
                                                                        value={blocks}
                                                                        onChange={(e) => {
                                                                            const newValue = parseInt(e.target.value, 10);
                                                                            setDataBlocks((prev) => ({
                                                                                ...prev,
                                                                                [key]: isNaN(newValue) ? 0 : newValue,
                                                                            }));
                                                                        }}
                                                                    />

                                                                    <IconButton
                                                                        onClick={() => {
                                                                            setDataBlocks((prev) => ({
                                                                                ...prev,
                                                                                [key]: (prev[key] || 0) + 1,
                                                                            }));
                                                                        }}
                                                                        size="small"
                                                                        className="data-block-button"
                                                                    >
                                                                        <Add fontSize="small" />
                                                                    </IconButton>
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}

                                                <TableRow>
                                                    <TableCell colSpan={3} style={{ textAlign: 'right' }}><strong>Totals:</strong></TableCell>
                                                    <TableCell>
                                                        <strong>
                                                            {
                                                                (() => {
                                                                    let totalData = 0;
                                                                    let dataUnit = '';

                                                                    formData?.subscriptionType?.data_block_products.forEach((row) => {
                                                                        const blocks = dataBlocks[row.product_id] || 0;
                                                                        totalData += blocks * row.data_amount;
                                                                        dataUnit = row.data_unit;
                                                                    });

                                                                    return `${totalData} ${dataUnit}`;
                                                                })()
                                                            }
                                                        </strong>
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>
                                                            {
                                                                (() => {
                                                                    let totalPrice = 0;
                                                                    let currency = '';

                                                                    formData?.subscriptionType?.data_block_products.forEach((row) => {
                                                                        const blocks = dataBlocks[row.product_id] || 0;
                                                                        totalPrice += blocks * row.price;
                                                                        currency = row.iso_currency_code;
                                                                    });

                                                                    return `${totalPrice.toFixed(0)} ${currency}`;
                                                                })()
                                                            }
                                                        </strong>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid> : null
                        }
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                options={combinedAddressOptions}
                                loading={isFetchingSuggestions}
                                filterOptions={(x) => x}
                                getOptionDisabled={(option: any) => option?.__source === 'header'}
                                getOptionLabel={(option: any) => {
                                    if (typeof option === 'string') return option;
                                    if (option?.__source === 'header') return '';
                                    return option?.formattedAddress || option?.formatted_address || '';
                                }}
                                isOptionEqualToValue={(option: any, value: any) => {
                                    const optKey = option?.placeId || option?.id || option?.formattedAddress || option?.formatted_address;
                                    const valKey = value?.placeId || value?.id || value?.formattedAddress || value?.formatted_address;
                                    return optKey && valKey && optKey === valKey;
                                }}
                                value={selectedAddress}
                                inputValue={addressSearchInput}
                                onInputChange={(_event, newValue, reason) => {
                                    if (reason === 'input') {
                                        setAddressSearchInput(newValue);
                                    } else if (reason === 'clear') {
                                        setAddressSearchInput('');
                                        handleAddressSelect(null);
                                    }
                                }}
                                onChange={(_event, newValue: any) => {
                                    if (newValue?.__source === 'header') return;
                                    handleAddressSelect(newValue);
                                    const nextInput = newValue?.formattedAddress || newValue?.formatted_address || '';
                                    if (nextInput !== addressSearchInput) {
                                        skipNextAddressSearchRef.current = true;
                                    }
                                    setAddressSearchInput(nextInput);
                                }}
                                noOptionsText={
                                    (addressSearchInput?.trim().length || 0) < 3
                                        ? ((savedAddresses?.length || 0) > 0
                                            ? 'Type at least 3 characters to search new addresses'
                                            : 'Type at least 3 characters to search')
                                        : (isFetchingSuggestions ? 'Searching...' : 'No matching addresses')
                                }
                                renderOption={(props, option: any) => {
                                    if (option?.__source === 'header') {
                                        return (
                                            <li
                                                {...props}
                                                key={`header-${option.label}`}
                                                style={{
                                                    pointerEvents: 'none',
                                                    backgroundColor: '#f5f5f5',
                                                    fontWeight: 600,
                                                    fontSize: '0.75rem',
                                                    color: '#555',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.04em',
                                                    borderBottom: '1px solid #ddd',
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                {option.label}
                                            </li>
                                        );
                                    }
                                    const key = option.placeId || option.id || option.formattedAddress || option.formatted_address;
                                    const label = option.formattedAddress || option.formatted_address || '';
                                    return (
                                        <li {...props} key={key} style={{ paddingLeft: 20 }}>{label}</li>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Address" size="small" placeholder="Start typing address..." />
                                )}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!mobileTerminal}
                                        onChange={(e) => setMobileTerminal(!mobileTerminal)}
                                        size="small"
                                    />
                                }
                                label="Use Street Address for Map Location"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {/* <Autocomplete
                                fullWidth
                                multiple
                                options={filteredTerminalArray}
                                getOptionLabel={(option) => `${option?.userTerminal} - ${option?.kitSerialNumber} - ${option?.dishSerialNumber}`}
                                value={filteredTerminalArray?.filter(option => formData?.terminalId?.includes(option?.userTerminal)) || []}
                                onChange={(event, newValue) => {
                                    setSelectedTerminals(newValue)
                                    handleChange('terminalId', newValue.map(item => item?.userTerminal));
                                }}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            style={{ marginRight: 8 }}
                                        />
                                        {`${option?.userTerminal} - ${option?.kitSerialNumber} - ${option?.dishSerialNumber}`}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Starlink ID, Starlink Serial Number, or Kit Serial Number"
                                        size="small"
                                    />
                                )}
                            /> */}
                            <Autocomplete
                                disableClearable
                                fullWidth
                                freeSolo
                                ListboxProps={{ style: { maxHeight: 340, overflow: "auto", padding: 0 },   }}
                                slotProps={{ popper: {    modifiers: [{ name: "flip", enabled: false }],   placement: "bottom-start", },}}
                                options={filteredTerminalArray}
                                getOptionLabel={(option: any) =>  typeof option === "string" ? option : option.label  }
                                value={ filteredTerminalArray.find( (option: any) => !option.isHeader && option?.userTerminal === formData?.terminalId ) || null}
                                inputValue={inputValue}
                                onInputChange={(e, newValue) => handleInputChange(newValue, setInputValue)}
                                onChange={(event, newValue: any) => handleOptionChange(  newValue, setValidationResult, setSelectedTerminals, handleChange,validateKITInput )}
                                filterOptions={filterTerminalOptions}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            validationResult
                                                ? validationResult.valid
                                                    ? `Valid ${validationResult.type}`
                                                    : `Invalid ${validationResult.type}`
                                                : "Starlink ID, Starlink Serial Number, or Kit Serial Number"
                                        }
                                        size="small"
                                        error={validationResult?.valid === false}
                                    />
                                )}
                                renderOption={renderTerminalOption}
                            />

                        </Grid>
                        <Grid item xs={12}>
                            <Box>
                                <Paper
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        padding: '8px',
                                        borderRadius: '10px',
                                        border: '1px solid #c2d3eb',
                                        boxShadow: 'none',
                                    }}
                                >
                                    {emails.map((email: any, index) => (
                                        <Chip
                                            key={index}
                                            label={email?.email}
                                            onDelete={() => handleDeleteEmail(email)}
                                            sx={{ margin: '4px' }}
                                        />
                                    ))}
                                    <TextField
                                        size="small"
                                        fullWidth
                                        variant="standard"
                                        error={!!error}
                                        placeholder="Press Enter to add email"
                                        helperText={error}
                                        value={emailInput}
                                        onChange={(e) => setEmailInput(e.target.value)}
                                        onKeyDown={handleAddEmail}
                                        InputProps={{
                                            disableUnderline: true,
                                            style: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                padding: '0 4px',
                                            },
                                        }}
                                        sx={{
                                            width: 'auto',
                                            flexGrow: 1,
                                            minWidth: '120px',
                                            '& .MuiInputBase-root': {
                                                display: 'flex',
                                                flexWrap: 'wrap', 
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '8px 4px',
                                                flex: 1,
                                            },
                                        }}
                                    />
                                </Paper>
                            </Box>
                            <Typography variant="caption" color="textSecondary" sx={{ marginTop: '4px', marginLeft: '8px' }}>
                                Press Enter to add Email. Quota Kontrol Notifications shall be sent to this email.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box>
                                <TextField
                                    fullWidth
                                    label="Deployment"
                                    variant="outlined"
                                    size="small"
                                    value={notes}
                                    inputProps={{ maxLength: 250 }}
                                    helperText={`${notes?.length || 0}/250 characters`}
                                    onChange={(e) => setNotes(e.target.value)}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
                            <Button
                                variant="outlined"
                                style={{ marginRight: '10px' }}
                                onClick={() => { clearData(); onClose(); }}
                            >
                                CANCEL
                            </Button>
                            <Button 
                                disabled={(formData?.subscriptionType?.data_block_products && formData?.subscriptionType?.data_block_products?.length > 0 && _.isEmpty(dataBlocks))
                                    || _.isEmpty(formData?.terminalId) || formData?.serviceAddress === null || formData?.subscriptionType === null
                                    || formData?.nickname === '' || selectedAccount === '' || validationResult?.type === 'UNKNOWN' 
                                    || validationResult?.type === 'CHARACTER'}
                                variant="outlined"
                                onClick={handleSubmit}
                            >
                                {isLoading ? <CircularProgress size={24} /> : "ADD SERVICE LINE"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            <Dialog PaperProps={{
                sx: {
                    width: '500px',
                    maxWidth: '500px'
                }
            }} open={confirmDialog} onClose={() => { setConfirmDialog(false) }}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography> Following Terminals will be moved from {selectedTerminals?.accountNumber} to {selectedAccount}: </Typography>

                    {selectedTerminals.kitSerialNumber && selectedTerminals.userTerminal ?
                        <ListItem key={selectedTerminals.userTerminal}>
                            <ListItemText primary={selectedTerminals.kitSerialNumber} secondary={`Starlink Id: ${selectedTerminals.userTerminal}`} />
                        </ListItem> : <></>}

                    <ListItem key={selectedTerminals.userTerminal}>
                        <ListItemText primary={"Plan"} secondary={` ${formData?.subscriptionType?.name || formData?.subscriptionType?.plan_name || ""}`} />
                    </ListItem>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialog(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { createServiceLines(); setConfirmDialog(false) }}
                        disabled={isLoading}
                        variant="contained"
                        color="primary"
                    >
                        {'Add'}
                    </Button>
                </DialogActions>
            </Dialog>

            {isLoading ? (
                <CustomLoader
                    showLoader={isLoading}
                    loadingText={"Creating Service Line. Please wait..."}
                />
            ) : null}
        </>
    );

}

const mapStateToProps = (state: any) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    starlinkAdmin: state.starlinkAdmin,
    starlinkCloud: state.starlinkCloud,
    dpIds: state.starlinkCloud.dpIds,
    newSummaryServiceAccount :  state.authReducer?.newSummaryServiceAccount,
    selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
});

export default withRouter(
    connect(mapStateToProps, {
        createSubOrg,
        createServiceLine,
        geocodeServiceAddress,
        getServiceLinesByStatusAPI
    })(CreateServiceLineDialog)
);